import { STATUS } from "@/lib/api";

export default function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.sem_vencimento;
  return (
    <span
      data-testid={`status-${status}`}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold"
      style={{ color: s.text, background: s.bg, border: `1px solid ${s.border}` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.text }} />
      {s.label}
    </span>
  );
}
